<template>
    <div
        :class="{
            seat: true,
            occupied: type === SeatType.Occupied,
            placeholder: type === SeatType.Placeholder,
            active: type === SeatType.Selected,
        }"
        @click="emit('click')"
    >
        {{ seatLabel }}
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { SeatType } from '../../types';

interface Props {
    type: SeatType;
    value?: number;
}

const props = defineProps<Props>();

const emit = defineEmits({
    click: () => true,
});

const seatLabel = computed(() => ((!props.type || [SeatType.Selected, SeatType.Available].includes(props.type)) && props.value) || '');

</script>
